import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const CustomTabsTimelineSub = ({
  tabs = [],
  tabProps,
  customClass,
  current,
  setCurrent,
  ...rest
}) => {
  // Safe initial key: "0" if current is null/undefined/NaN
  const safeKey = Number.isFinite(Number(current)) ? String(current) : '0';
  const [activeTab, setActiveTab] = useState(safeKey);

  const onChange = key => {
    setActiveTab(key); // key is string
    if (typeof setCurrent === 'function') setCurrent(Number(key));
  };

  useEffect(() => {
    const next = Number.isFinite(Number(current)) ? String(current) : '0';
    setActiveTab(next);
  }, [current]);

  if (!tabs.length) return null;

  return (
    <div className={customClass || ''}>
      <Tabs
        // Controlled: use only activeKey (remove defaultActiveKey)
        activeKey={activeTab}
        onChange={onChange}
        className="fullwidth-tabs"
        {...rest}
      >
        {tabs.map(({ label, Component }, index) => (
          <TabPane
            key={String(index)} // keys must be strings
            tab={
              <div className="tab-timeline">
                <div className="tab-timeline-label">{label}</div>
              </div>
            }
          >
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimelineSub;
